<template>
    <div>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                   <div class="row breadcrumbs-top">
                      <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Vehicle Schedule </h3>
                        
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Schedules</a>
                                </li>
                                <li class="breadcrumb-item"><a href="#">Vehicle Calendar</a>
                            </li>
                            
                                
                               
                            </ol>
                        </div>
                      </div>
                   </div>
                </div>
                
            </div>
            <div class="card content-body">
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <div class="card-header px-0  common_top_title_searchbgst_dock">
                    <div class="container-fluid " >
                        <div class="row row fc_my-05">
                            <div class="w-auto px-1 mobile-padding-0-2">
                                <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                    <div class="avatar-content">
                                        <em class="las la-calendar-week i_icon_st font-medium-5"></em>
                                    </div>
                                </div>
                                
                                <h4 class="card-title d-inline-flex ml-0 mb-0">Vehicle Schedule Calendar</h4>
                            </div>
                        </div>    
                            
                    </div>
                </div>
                <section>
                    <div class=" p-1 calendar_vehicle_Schedule09">
                      <div id="calendar"></div>
                    </div>
                    <div class="modal" id="calendarModal" tabindex="2" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div class="modal-content full_calendar_style_02">
                                <div class="modal-header" style="text-align: center;">
                                    <h4 id="title" class="modal-title"></h4>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <em class="las la-times-circle"></em>
                                    </button>
                                </div>
                                <div class="modal-body mb-0">
                                    <div class="row">
                                        <div class="col-md-6 from-group mb-1">
                                            <label class="form-label lable-left font-weight-bolder">Vehicle Number :</label>
                                            <span class="font-weight-normal d-block" id="vehiclenumber"></span>
                                        </div>
                                        <div class="col-md-6 from-group mb-1">
                                            <label class="form-label lable-left font-weight-bolder">Route Path :</label>
                                            <span class="font-weight-normal d-block" id="routepath"></span>
                                        </div>
                                        <div class="col-md-6 from-group mb-1">
                                            <label class="form-label lable-left font-weight-bolder"> Arrival Date: </label>
                                            <span class="font-weight-normal d-block" id="arraivdate"></span>
                                        </div>
                                        <div class="col-md-6 from-group mb-1">
                                            <label class="form-label lable-left font-weight-bolder"> Departure Date: </label>
                                            <span class="font-weight-normal d-block" id="departuredate"></span>
                                        </div>
                                        <div class="col-md-6 from-group mb-1">
                                            <label class="form-label lable-left font-weight-bolder"> Driver Details: </label>
                                            <span class="font-weight-normal d-block" id="drivernumber"></span>
                                        </div>
                                        <div class="col-md-6 from-group mb-1">
                                            <label class="form-label lable-left font-weight-bolder"> Weight: </label>
                                            <span class="font-weight-normal d-block" id="weight"></span>
                                        </div>
                                    </div>
                                </div>    
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios"
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import VueElementLoading from 'vue-element-loading'
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"

export default({
    name:'mastersTable',
    mixins: [ common_methods, searchMasterNameList],
    components: {
        DatePicker,
        VueElementLoading,
        
    },
    data() {
        return {
            un:'',
            isLoading: false,
            calendarEvents : [],
        }
    } ,
    mounted(){
        this.calendar = this.initializeCalendar();
        window.addEventListener('storage', function(event){
            if (event.key == 'logout-mee') { 
              window.location.reload();
            }
        });
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        let userdata = window.localStorage.getItem('userdata');
        if(userdata){
            userdata = JSON.parse(userdata);
            this.undt=userdata;
            this.calendermasterlist();
        }
    },
    watch: {
        calendarEvents: {
            handler() {
                this.calendar.removeAllEvents();
                this.calendar.addEventSource(this.calendarEvents);
            },
            deep: true
        }
    },
    methods:{
        calendermasterlist(startdate,enddate){
             let temdata =[
             {
                    'vehicleid':'1',
                    'title':'MH14LB9624', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-PHR-JJR-BAR',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'2',
                    'title':'MH14EM3300', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-BLRO',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'3',
                    'title':'MH14KQ6037', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-KRD-GOI',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'4',
                    'title':'MH11CJ5437', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-KRD-KOP-BGM-HBL',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'5',
                    'title':'MH14JL9476', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-IDRO',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'6',
                    'title':'RJ23GC2332', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-BOMD-UDR-JAIO',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'7',
                    'title':'MH11BL7365', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-STR-KRD-KOP',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'8',
                    'title':'MH14LB8170', //vegicleno/type
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 17:16:57',
                    'route':'PNQO-NAGO-RPR',
                    "backgroundColor": "#FE9301",
                },
                {
                    'vehicleid':'9',
                    'title':'MH14GU7300',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 15:12:00',
                    'route':'PNQO-BLRO-SLMO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'10',
                    'title':'MH14HG9963',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 15:12:00',
                    'route':'PNQO-KKB-SPR',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'11',
                    'title':'MH04KF1874',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 15:12:00',
                    'route':'AMDO-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'12',
                    'title':'HR55AL8907',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 15:16:57',
                    'departuredate':'2024-01-05 16:12:00',
                    'route':'BDQN-VPI-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'13',
                    'title':'MH43BG7399',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 13:10:57',
                    'departuredate':'2024-01-06 17:12:00',
                    'route':'BOMD-PNQO',
                    "backgroundColor": "#FE9301"
                },{
                    'vehicleid':'14',
                    'title':'MH04HD5614',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 17:16:57',
                    'departuredate':'2024-01-05 19:12:00',
                    'route':'BOMD-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'15',
                    'title':'GJ38T2267',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 17:16:57',
                    'departuredate':'2024-01-05 19:12:00',
                    'route':'CCUO-NAGO-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'16',
                    'title':'RJ11GC7122',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 13:16:57',
                    'departuredate':'2024-01-05 19:12:00',
                    'route':'DELH-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'17',
                    'title':'MH11DD5437',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 12:16:57',
                    'departuredate':'2024-01-05 14:12:00',
                    'route':'HBL-BGM-KOP-KRD-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'18',
                    'title':'RJ14GK0386',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 16:10:57',
                    'departuredate':'2024-01-05 19:30:00',
                    'route':'JSPO-SMB-NAGO-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'19',
                    'title':'HR55AR3733',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 14:00:57',
                    'departuredate':'2024-01-05 16:40:00',
                    'route':'NDAO-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'20',
                    'title':'MH40CM3087',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 10:16:57',
                    'departuredate':'2024-01-05 12:00:00',
                    'route':'RPR-NAGO-PNQO',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'21',
                    'title':'HR55AM9994',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 10:10:57',
                    'departuredate':'2024-01-05 13:12:00',
                    'route':'BLRO-PNQO-BOMD',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'22',
                    'title':'MH04HY2321',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 17:16:57',
                    'departuredate':'2024-01-05 19:12:00',
                    'route':'CJB-TPR-PNQO-BOMD',
                    "backgroundColor": "#FE9301"
                },
                {
                    'vehicleid':'23',
                    'title':'MH16CD6182',
                    'start':'2024-01-05', //arraivaldate
                    'arraivaldate':'2024-01-05 17:16:57',
                    'departuredate':'2024-01-05 19:12:00',
                    'route':'HYDO-PNQO-BOMD',
                    "backgroundColor": "#FE9301"
                }
            ]
            // this.calendarEvents  = temdata;
            this.isLoading =true;
            this.input = {
                useremail: this.undt.username,
                empcode: this.undt.userid,
                location: this.undt.location ? this.undt.location :null
            }
            if(startdate != undefined && enddate != undefined){
                this.input.startdate =  startdate;
                this.input.enddate =  enddate;
            }else{
        
            let gdate = new Date();
                let firstDay = new Date(gdate.getFullYear(), gdate.getMonth(), 1);
                let lastDay = new Date(gdate.getFullYear(), gdate.getMonth() + 1, 0);        
                this.input.startdate =  moment(String(firstDay)).format('YYYY-MM-DD');
                this.input.enddate =  moment(String(lastDay)).format('YYYY-MM-DD');
            }
            let url = '/vehicle/getvehiclecalendardata'
            this.makeRequest("POST", url, this.input)
            .then(result => {  
                this.isLoading=false;
                if(result.data.errorCode == 0){
                    this.calendarEvents = result.data.data.rows;
                }else{
                    this.calendarEvents = [];
                }
            })
            .catch(e => {
                this.displayError(e)
            })
        }, 
        initializeCalendar() {
            const calendar = new FullCalendar.Calendar(document.getElementById('calendar'), {
                initialView: 'dayGridMonth',
                events: this.calendarEvents,
                headerToolbar: {
                    start: 'sidebarToggle, prev,next, title',
                    end: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
                },
                eventClick: function(info) {
                    let arrdate = moment(String(info.event.extendedProps.arraivaldate)).format('YYYY-MM-DD HH:mm:ss');
                    let deptdate = moment(String(info.event.extendedProps.departuredate)).format('YYYY-MM-DD HH:mm:ss');
                    $('#title').html(info.event.title);
                    let vehicleid = info.event.extendedProps.vehicleid; 
                    $('#vehiclenumber').text(info.event.title);
                    $('#routepath').text(info.event.extendedProps.route);
                    $('#arraivdate').text(arrdate);
                    $('#departuredate').text(deptdate);
                    $('#drivernumber').text(info.event.extendedProps.drivernumber ? info.event.extendedProps.drivernumber :'NA');
                    $('#weight').text(info.event.extendedProps.weight ? info.event.extendedProps.weight :'NA');
                    $('#calendarModal').modal();
                },
                datesSet: this.handleDatesSet,
            });
            calendar.render();
            return calendar;
        },
        handleDatesSet(info) {
            let calenderapi = info.view.calendar;
            let isstart = calenderapi.view.activeStart;
            let isend = calenderapi.view.activeEnd;
            let startdate = moment(String(isstart)).format('YYYY-MM-DD');
            let enddate = moment(String(isend)).format('YYYY-MM-DD');
            this.updatecalendar(startdate, enddate);
        },
        updatecalendar(startdate, enddate) {
            try{
                this.calendermasterlist(startdate,enddate);
            }catch(error){
                console.log(error,'error');
            }
        },
    }
})
</script>